import { SmartToy as SmartToyIcon, Person as PersonIcon } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress
} from '@mui/material';
import { marked } from 'marked';
import DataTable from './DataTable';
import { useState } from 'react';

const ChatComponent = ({ index, message }) => {
  const assistantBubbleBg = '#FFFFFF00';
  const userBubbleBg = '#F4F4F4';
  const isUser = message.role === 'user';
  const canDownload = message.canDownload;
  const messageBg = isUser ? userBubbleBg : assistantBubbleBg;
  const textColor = isUser ? '#0A2440' : '#0A2440';
  const IconComponent = isUser ? PersonIcon : SmartToyIcon;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loadingDownload, setLoadingDownload] = useState(false);

  const fadeInStyle = {
    '@keyframes fadeIn': {
      from: { opacity: 0, transform: 'translateY(5px)' },
      to: { opacity: 1, transform: 'translateY(0)' }
    },
    animation: 'fadeIn 0.5s ease-in-out',
  };

  const downloadDataAsPDF = async () => {
    setLoadingDownload(true);
    try {
      const response = await fetch(`${apiUrl}/api/download-pdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ sql_query: message.sql_query, question: message.question }),
      });

      if (!response.ok) {
        throw new Error('Failed to download PDF');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'query_result.pdf');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error('PDF download error:', error);
      alert('There was an error downloading the PDF. Please try again.');
    } finally {
      setLoadingDownload(false);
    }
  };

  const renderDownloadButton = () => (
    <Button
      variant="outlined"
      color="primary"
      sx={{ mt: 1, marginBottom: '10px'}}
      onClick={downloadDataAsPDF}
      disabled={loadingDownload}
    >
      {loadingDownload ? <CircularProgress size={20} /> : 'Download PDF'}
    </Button>
  );

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <Box key={index} sx={{ display: 'flex', justifyContent: isUser ? 'flex-end' : 'flex-start', mb: 1, ...fadeInStyle }}>
      <Box
        sx={{
          maxWidth: '80%',
          padding: 1.5,
          borderRadius: 2,
          backgroundColor: messageBg,
          color: textColor,
          fontFamily: 'Roboto, sans-serif',
          fontSize: '1rem',
          boxShadow: isUser ? '0px 2px 5px rgba(0,0,0,0.1)' : 'none',
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.5,
        }}
      >
        <Box sx={{ overflowWrap: 'break-word' }}>
          {typeof message.content === 'string' ? (
            <>
              <div dangerouslySetInnerHTML={{ __html: marked(message.content) }} style={{ marginBottom: '-10px'}}/>
              {!isUser && canDownload && renderDownloadButton()}
            </>
          ) : message.content?.type === 'table' ? (
            <>
              <DataTable headers={message.content.headers} rows={message.content.rows} />
              {!isUser && canDownload && renderDownloadButton()}
            </>
          ) : (
            <div>{JSON.stringify(message.content)}</div>
          )}
          <div
            style={{
              fontSize: '0.75rem',
              color: textColor,
              textAlign: isUser ? 'right' : 'left',
              marginTop: '1px',
              opacity: 0.8,
              lineHeight: 0.5,
            }}
          >
          {formatTime(message.timestamp)}
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatComponent;
